export interface StoredDocuments {
  fullPathName: string;
  documentName: string;
  dateStored: Date;
  storedBy: string;
}
